{
  "title": "Passform",
  "runsSmallLabel": "Fällt klein aus",
  "trueToSizeLabel": "Fällt normal aus",
  "runsLargeLabel": "Fällt groß aus",
  "confidenceText": "{value}% sicher basierend auf echtem Kundenfeedback",
  "loading": "Passform wird geladen...",
  "fitCategorySmall": "Fällt wahrscheinlich klein aus",
  "fitCategoryTrue": "Fällt normal aus",
  "fitCategoryLarge": "Fällt wahrscheinlich groß aus",
  "fallbackTruePill": "Wahrscheinlich normale Passform",
  "noDataPill": "Keine Daten verfügbar",
  "errorPill": "Vorübergehend nicht verfügbar",
  "recommendationHeadingSmall": "Erwägen Sie eine größere Größe",
  "recommendationHeadingTrue": "Sollte wie erwartet passen",
  "recommendationHeadingLarge": "Erwägen Sie eine kleinere Größe",
  "fallbackTrueHeading": "Sollte wie erwartet passen",
  "fallbackTrueSummary": "Wir haben noch nicht genügend Kundenfeedback für diesen Artikel, daher wird eine wahrscheinlich normale Passform angenommen.",
  "noDataHeading": "Keine Daten verfügbar",
  "noDataSummary": "Wir haben noch nicht genügend Kundenfeedback für diesen Artikel.",
  "errorHeading": "Passformempfehlung nicht verfügbar",
  "errorSummary": "Diese Passformempfehlung ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
  "fallbackSummarySmall": "Kundenfeedback deutet darauf hin, dass dieser Artikel kleiner als erwartet ausfallen könnte.",
  "fallbackSummaryTrue": "Kundenfeedback deutet darauf hin, dass dieser Artikel wie erwartet passen sollte.",
  "fallbackSummaryLarge": "Kundenfeedback deutet darauf hin, dass dieser Artikel größer als erwartet ausfallen könnte."
}